import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { DeviceService } from './device.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';
@Injectable({
	providedIn: 'root'
})

export class LoginService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	package: any = '';

	constructor(private globalSearchService:GlobalSearchService,private http: HttpClient, private httpClient: HttpClient, private _configSvc: RuntimeConfigLoaderService, private deviceService: DeviceService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.updateHeaders();
		})

	}
	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	private updateHeaders() {
		const uuid = this.deviceService.getDeviceUUID();
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		if (this.config && this.config.apiCredentials && this.config.apiCredentials.clientId) {
			headers = headers.set('Authorization', 'Bearer ' + this.config.apiCredentials.clientId);
		}
		headers = headers.set('X-Device-UUID', uuid);
		this.httpOptions.headers = headers;
	}
		
	public verify2FA(data) {
	
		const method = 'login/twofa';
		if (this.config.apiCredentials.clientId) {
			this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + this.config.clientId);
		}
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('login', data))
		);
	}
	
	public login(data) {

		const method = 'login';
		if (this.config.apiCredentials.clientId) {
			this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + this.config.clientId);
		}
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('login', data))
		);
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {

		// if (this.config.clientId) {
		// 	this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + this.config.clientId);
		//   }
		//
		//   // Check if userId exists before adding it to headers
		//   if (this.config.userId) {
		// 	this.httpOptions.headers = this.httpOptions.headers.set('UserId', this.config.userId);
		//   }
		//
		if (this.config.apiCredentials.clientId) {
			this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + this.config.apiCredentials.clientId);
		}

		return '&key=' + this.config.apiCredentials.clientId;

	}

	public getKey() {
		if (this.config.apiCredentials.clientId) {
			this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + this.config.apiCredentials.clientId);
		}
		return '&key=' + this.config.apiCredentials.clientId;

	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private handleError<T>(operation = 'operation', result?: T) {

		return (error: any): Observable<T> => {
			if (error instanceof HttpErrorResponse && error.status === 401) {
				alert('Access From this device is not allowed');
			}

			return throwError(() => error);
	  };
	}
}
